import React from 'react';

const eventLabels = {
  product_viewed: 'Produkt vist',
  add_to_cart: 'Lagt i handlekurv',
  checkout_started: 'Kasse startet',
  collection_viewed: 'Kategori vist',
  $pageview: 'Sidevisning',
  $pageleave: 'Forlot side',
};

function formatEventName(event) {
  return eventLabels[event] || event;
}

export default function EventsTable({ data, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Hendelser</h3>
        <div className="text-gray-400 text-sm py-8 text-center">Laster...</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Hendelser</h3>
        <span className="text-xs text-gray-400">Antall</span>
      </div>

      {(!data || data.length === 0) ? (
        <div className="text-gray-400 text-sm py-8 text-center">Ingen data ennå</div>
      ) : (
        <div className="space-y-1">
          {data.map((item, i) => (
            <div key={i} className="flex items-center justify-between px-3 py-2.5 rounded hover:bg-gray-50 transition-colors">
              <span className="text-sm text-gray-700">{formatEventName(item.event)}</span>
              <span className="text-sm font-semibold text-gray-900">{item.count.toLocaleString('nb-NO')}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
